import * as React from "react";
import axios from "axios";

import MenuItem from "@mui/material/MenuItem";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";

import Title from "../Layout/Title";

import { Button } from "@mui/material";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

import { Formik, Field } from "formik";
import * as yup from "yup";

export default function AddMessage({
  messages,
  setMessages,
  setOpen,
  setErrOpen,
  setErrMessage,
  refresh,
  setRefresh,
  setErr,
  initialVals,
}) {
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [resetKey, setResetKey] = React.useState(0);

  const initialValues = {
    message: initialVals.message,
    start: initialVals.start,
    end: initialVals.end,
    type: initialVals.type,
  };

  function dateFormat(date) {
    const newDate =
      "" +
      dayjs(date).year() +
      "-" +
      ("0" + (dayjs(date).month() + 1)).substring(
        ("0" + (dayjs(date).month() + 1)).length - 2
      ) +
      "-" +
      ("0" + dayjs(date).date()).substring(
        ("0" + dayjs(date).date()).length - 2
      );

    return newDate;
  }

  const userSchema = yup.object().shape({
    message: yup.string().required("Required"),
    start: yup.date().required("Required"),
    end: yup.date().required("Required"),
    type: yup.string().required("Required"),
  });

  const compareStartAndEndDate = (startDate, endDate, setFieldValue) => {
    const d1 = new Date(startDate);
    const d2 = new Date(endDate);

    if (startDate === endDate) return;

    if (startDate && endDate) {
      if (d1 > d2) {
        setFieldValue("end", "");
        setResetKey(resetKey + 1);
      }
    }
  };

  const myHandleReset = (values) => {
    values["start"] = initialVals.start;
    values["end"] = initialVals.end;
    setResetKey(resetKey + 1);
  };

  const handleSubmit = (values) => {
    values.start = dateFormat(values.start);
    values.end = dateFormat(values.end);

    setMessages([
      {
        id: Math.max(...messages.map((m) => m.id)) + 1,
        message: values.message,
        start: values.start,
        end: values.end,
        type: values.type,
      },
      ...messages,
    ]);
    setRefresh(refresh + 1);

    setOpen(false);

    axios
      .post(`/addmessage`, { values: values })
      .then()
      .catch((err) => {
        setErrMessage(err.response.data);
        setErrOpen(true);
      });
  };

  return (
    <div>
      <Title>Create New Message</Title>

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={userSchema}
      >
        {({
          values,
          errors,
          touched,
          resetForm,
          handleSubmit,
          handleChange,
          setFieldValue,
          handleBlur,
          setFieldTouched,
          isValidating,
        }) => (
          <form onSubmit={handleSubmit} onReset={resetForm}>
            <Box
              id="editForm"
              sx={{
                mt: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextField
                margin="normal"
                fullWidth
                id="message"
                label="message"
                name="message"
                variant="standard"
                value={values.message}
                onChange={handleChange}
                error={!!touched.message && !!errors.message}
                helperText={touched.message && errors.message}
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  key={resetKey}
                  label="start"
                  inputFormat="DD/MM/YYYY"
                  disablePast
                  variant="standard"
                  value={values.start}
                  name="start"
                  // onBlur={handleBlur}

                  onChange={(newValue) => {
                    setFieldTouched("start", true);
                    setFieldValue("start", newValue);
                    setStartDate(newValue);
                    compareStartAndEndDate(newValue, endDate, setFieldValue);
                    // setFieldTouched("start", true);
                  }}
                  renderInput={(params) => {
                    return (
                      <TextField
                        {...params}
                        fullWidth
                        margin="dense"
                        variant="standard"
                        onKeyDown={(e) => e.preventDefault()}
                        error={!!touched.start && !!errors.start}
                        helperText={touched.start && errors.start}
                      />
                    );
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  key={resetKey}
                  label="end"
                  inputFormat="DD/MM/YYYY"
                  disablePast
                  minDate={startDate}
                  variant="standard"
                  value={values.end}
                  name="end"
                  onChange={(newValue) => {
                    setEndDate(newValue);
                    setFieldTouched("end", true);
                    setFieldValue("end", newValue);
                  }}
                  renderInput={(params) => {
                    return (
                      <TextField
                        {...params}
                        fullWidth
                        margin="dense"
                        variant="standard"
                        error={!!touched.end && !!errors.end}
                        helperText={touched.end && errors.end}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    );
                  }}
                />
              </LocalizationProvider>
              <TextField
                select
                margin="normal"
                fullWidth
                id="type"
                label="type"
                name="type"
                variant="standard"
                value={values.type}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.type && !!errors.type}
                helperText={touched.type && errors.type}
              >
                <MenuItem key={"info"} value="0">
                  info
                </MenuItem>
                <MenuItem key={"success"} value="1">
                  success
                </MenuItem>
                <MenuItem key={"warning"} value="2">
                  warning
                </MenuItem>
                <MenuItem key={"danger"} value="3">
                  danger
                </MenuItem>
              </TextField>

              <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }}>
                Add
              </Button>
              <Button
                type="reset"
                variant="contained"
                color="secondary"
                onClick={() => {
                  myHandleReset(values);
                }}
              >
                Reset
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </div>
  );
}
